import { MapPin, Phone, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY } from "@/data/site";
import { CITY_LIST } from "@/data/cities";

export default function ServiceArea() {
  // Google Maps embed centered on Roseville, MI (no API key required for basic embed)
  const mapSrc =
    "https://www.google.com/maps?q=Roseville,+Macomb+County,+MI&hl=en&z=10&output=embed";

  return (
    <section id="area" className="bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-5">
            <div className="label-eyebrow">Service area</div>
            <h2 className="font-display text-4xl md:text-5xl font-black tracking-tight mt-2 text-slate-900">
              Proudly serving Macomb County, MI.
            </h2>
            <p className="text-slate-600 md:text-lg mt-4 max-w-md">
              Based in Roseville, dispatched fast across the surrounding communities.
              Not sure if we cover your area? Just call — chances are we do.
            </p>

            <div className="mt-6 flex flex-wrap gap-2" data-testid="service-area-list">
              {CITY_LIST.map((c) => (
                <Link
                  key={c.slug}
                  to={`/service-areas/${c.slug}`}
                  data-testid={`home-service-area-${c.slug}`}
                  className="group inline-flex items-center gap-1.5 text-xs font-semibold text-slate-700 bg-white border border-slate-200 hover:border-[#C5A572] hover:text-[#1E3A5F] rounded-full px-3 py-1.5 transition"
                >
                  <MapPin size={11} className="text-[#C5A572]" />
                  {c.name}
                  <ArrowRight size={11} className="text-[#A88852] opacity-0 group-hover:opacity-100 transition" />
                </Link>
              ))}
            </div>

            <Link
              to="/service-areas"
              data-testid="home-view-all-areas"
              className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#A88852] hover:underline"
            >
              View all service areas <ArrowRight size={14} />
            </Link>

            <a
              href={`tel:${COMPANY.phoneTel}`}
              data-testid="service-area-call"
              className="btn-cta mt-7 inline-flex items-center gap-2 px-5 py-3 text-sm"
            >
              <Phone size={16} /> Call {COMPANY.phone}
            </a>
          </div>

          <div className="lg:col-span-7">
            <div className="relative rounded-md overflow-hidden border border-slate-200 bg-white">
              <iframe
                data-testid="service-area-map"
                title="Service area map"
                src={mapSrc}
                width="100%"
                height="460"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <div className="absolute left-4 bottom-4 bg-white border border-slate-200 rounded-md px-4 py-2 shadow-md">
                <div className="text-[11px] uppercase tracking-wider text-slate-500">Headquartered in</div>
                <div className="font-display font-bold text-slate-900">{COMPANY.city}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
